module.exports = __webpack_public_path__ + "assets/c4a0dc0e84f2b653de55fb5f2d05b621.mp3";